import { Button } from '../../../../..'
import styles from './SavedSearchAlertModalFooterButtons.module.scss'

export interface SavedSearchAlertModalFooterButtonsProps {
  isDestructiveAlert: boolean
  primaryButtonMessage: string
  secondaryButtonMessage: string
  handleClose: () => void
  handlePrimaryClick: () => void
}

export const SavedSearchAlertModalFooterButtons = ({
  isDestructiveAlert,
  primaryButtonMessage,
  secondaryButtonMessage,
  handleClose,
  handlePrimaryClick,
}: SavedSearchAlertModalFooterButtonsProps) => {
  return (
    <div className={styles.buttonContainer}>
      <Button onClick={handleClose}>{secondaryButtonMessage}</Button>
      <Button primary danger={isDestructiveAlert} onClick={handlePrimaryClick}>
        {primaryButtonMessage}
      </Button>
    </div>
  )
}
